var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120.193,
    height: 157.893,
    viewBox: "0 0 120.193 157.893",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3484",
    transform: "translate(-153.903 -389.396)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    d: "M739.944,832.226H648.96c-10.946,0-17.991-9.776-12.938-17.952l45.492-73.613c5.448-8.817,20.428-8.817,25.875,0l45.492,73.613C757.935,822.45,750.89,832.226,739.944,832.226Z",
    transform: "translate(-480.452 -330.652)",
    fill: "#f0322a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    transform: "translate(45.172 -9.754)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    d: "M672.2,866.771l9.564-123.94,10.868,123.94Z",
    transform: "translate(-513.585 -332.048)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    width: 25.73,
    height: 6.177,
    transform: "translate(155.963 436.281)",
    fill: "#f0322a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    width: 25.73,
    height: 14.377,
    transform: "translate(155.963 463.411)",
    fill: "#f0322a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    transform: "translate(-478.7 -307.643)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    d: "M634.927,854.58v-8.719H658.64v-6.276h-9.067q-5.639,0-7.323-.174a11.686,11.686,0,0,1-3.6-1.044,7.986,7.986,0,0,1-3.835-3.856,14.968,14.968,0,0,1-1.337-6.7,14.576,14.576,0,0,1,1.279-6.261,8.838,8.838,0,0,1,3.6-4.06,10.484,10.484,0,0,1,3.486-1.275,35.1,35.1,0,0,1,5.755-.348h18.83v8.717H644.052v6.277h11.534a30.166,30.166,0,0,1,5.562.407,10.562,10.562,0,0,1,3.7,1.453q4.484,2.847,4.485,9.59a15.116,15.116,0,0,1-1.162,6.132,9.183,9.183,0,0,1-3.371,4.1,11.284,11.284,0,0,1-3.894,1.571,30.811,30.811,0,0,1-6.045.464Z",
    transform: "translate(0 0.062)",
    fill: "#f0322a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    d: "M685.5,815.643q4.533,0,6.54.174a17.606,17.606,0,0,1,3.689.7q4.417,1.511,5.812,4.911t1.4,12.815a77.825,77.825,0,0,1-.581,11.508,10.351,10.351,0,0,1-2.383,5.346,10.586,10.586,0,0,1-5.609,3.023,57.514,57.514,0,0,1-11.479.813q-5.115,0-7.062-.174a16.106,16.106,0,0,1-3.923-.873,8.976,8.976,0,0,1-5.7-5.143q-1.395-3.574-1.394-13.338a71.986,71.986,0,0,1,.581-11.19,9.734,9.734,0,0,1,2.529-5.172,10.137,10.137,0,0,1,5.463-2.7A71.525,71.525,0,0,1,685.5,815.643Zm-9.764,30.571h16.39V824.361h-16.39Z",
    transform: "translate(8.419 0)",
    fill: "#f0322a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    d: "M699.382,854.58v-8.719h23.713v-6.276h-9.067q-5.639,0-7.323-.174a11.686,11.686,0,0,1-3.6-1.044,7.992,7.992,0,0,1-3.835-3.856,14.971,14.971,0,0,1-1.337-6.7,14.575,14.575,0,0,1,1.279-6.261,8.841,8.841,0,0,1,3.6-4.06,10.464,10.464,0,0,1,3.486-1.275,35.075,35.075,0,0,1,5.754-.348h18.83v8.717H708.507v6.277h11.534a30.156,30.156,0,0,1,5.562.407,10.563,10.563,0,0,1,3.7,1.453q4.484,2.847,4.486,9.59a15.119,15.119,0,0,1-1.163,6.132,9.184,9.184,0,0,1-3.371,4.1,11.273,11.273,0,0,1-3.894,1.571,30.812,30.812,0,0,1-6.045.464Z",
    transform: "translate(17.319 0.062)",
    fill: "#f0322a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d9d99cdd35478d940402b73dccefdb37.svg";
export { ForwardRef as ReactComponent };